import './style.scss'
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next'
import { BackButton, MainButton, useWebApp } from '@vkruglikov/react-telegram-web-app';
import SettingsApi from '@/features/Settings/api'
import { useParams } from 'react-router-dom';
import { useErrorBoundary } from 'react-error-boundary';
import useEnvInitData from '@/hooks/useEnvInitData'
import Alert from "@/components/Alert";
import BottomSheet from 'react-draggable-bottom-sheet';
import { HandySvg } from 'handy-svg';
import IconClose from "@/icons/close.svg";

export default function Level({ data, setData, back, members }) {
	const { raffle_id } = useParams();
	const { t } = useTranslation()
	const [value, setValue] = useState(data.level ?? 0)
	const WebApp = useWebApp();
	const [saving, setSaving] = useState(false)
	const { showBoundary } = useErrorBoundary()
	const [InitDataUnsafe, InitData] = useEnvInitData();
	const [alert, showAlert] = useState(false)
	const [confirm, setConfirm] = useState(false)

	const handleSave = () => {
		if (saving) return;
		setSaving(true);

		SettingsApi.levelSave({
			initData: InitData,
			raffle: raffle_id,
			value: value,
		}).then(function(result) {
			if (result.result) {
				showAlert(true)
				setTimeout(() => {
					showAlert(false)
				}, 3500)
			}
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setConfirm(false)
			setSaving(false)
			setData(prev => ({
				...prev,
				level: value
			}));
		})
	}

	const texts = {
		0: {
			title: t('features.settings.shield.level.list.0.title'),
			text: <Trans i18nKey="features.settings.shield.level.list.0.text" components={{ p: <p /> }} />
		},
		1: {
			title: t('features.settings.shield.level.list.1.title'),
			text: <Trans i18nKey="features.settings.shield.level.list.1.text" components={{ p: <p />, ul: <ul />, li: <li /> }} />
		},
		2: {
			title: t('features.settings.shield.level.list.2.title'),
			text: <Trans i18nKey="features.settings.shield.level.list.2.text" components={{ p: <p />, ul: <ul />, li: <li /> }} />
		},
		3: {
			title: t('features.settings.shield.level.list.3.title'),
			text: <Trans i18nKey="features.settings.shield.level.list.3.text" components={{ p: <p />, ul: <ul />, li: <li /> }} />
		}
	}

	return (
		<div className='Level'>
			<BackButton onClick={back} />
			<div className='boxText'>
				<div className='boxText_body'>
					<div className='Level__range-wrap'>
						<div className='Level__range-bg'>
							<span></span>
							<span></span>
							<span></span>
							<span></span>
						</div>

						<RangeSlider
							className='Level__range'
							min={0}
							max={3}
							step={1}
							defaultValue={[0, value]}
							thumbsDisabled={[true, false]}
							rangeSlideDisabled={true}
							onInput={(v) => {
								setValue(v[1])
							}}
						/>
					</div>
					<div className='Level__text'>
						<div className='Level__text-title' aria-valuenow={value}>{texts[value].title}</div>
						{texts[value].text}
						<p>{t('features.settings.shield.level.help')} <button onClick={members} className='Level__button' type='button'>{t('features.settings.shield.level.btn')}</button>.</p>
					</div>
				</div>
			</div>
			{!data.is_vip ?
				<div className='boxText'>
					<div className='boxText_body'>
						<p>{ t('features.settings.vip_text') }</p>
						<button
							className='btn btn--block btn--light btn--tt-none'
							onClick={() => {
								WebApp.openTelegramLink(process.env.REACT_APP_LINK_TO_BOT + '?start=vip-clear')
								WebApp.close()
							}}
						>
							{ t('features.settings.vip_btn') }
						</button>
					</div>
				</div>
			:
				<MainButton
					className='btn btn--block'
					onClick={() => confirm ? handleSave() : setConfirm(true)}
					disabled={saving}
					progress={saving}
					text={confirm ? t('features.settings.shield.level.save') : t('features.settings.shield.level.confirm_btn')}
				/>
			}
			{alert && <Alert>{t('features.settings.shield.text_save')}</Alert>}
			{confirm ?
				<BottomSheet isOpen={confirm} close={() => setConfirm(false)} disabled>
					<button className='BottomSheetClose' onClick={() => setConfirm(false)}><HandySvg src={IconClose}/></button>
					<div className='boxText'>
						<div className='boxText_body'>
							<p><b>{texts[value].title}</b></p>
							{value === 0 ?
								<Trans i18nKey="features.settings.shield.level.warning_0" components={{ p: <p />, b: <b/> }} />
							:
								<>
									<Trans i18nKey="features.settings.shield.level.warning" components={{ p: <p />, b: <b/> }} />
									<p>{t('features.settings.shield.level.help_confirm')} <button onClick={() => {
										setConfirm(false)
										members()
									}} type='button' className='Level__button'>{t('features.settings.shield.level.btn')}</button>.</p>
								</>
							}
						</div>
					</div>
				</BottomSheet>
			: null}
		</div>
	)
}
